import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const BrandingContext = createContext(null);

const DEFAULTS = {
  title: "MLILY Warranty Hub",
  subtitle: "Warranty Training Centre",
  logoUrl: "/mlily-logo.png",
  faviconUrl: "/favicon.png",
};

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/branding`);
      setBranding({
        title: data.title || DEFAULTS.title,
        subtitle: data.subtitle || DEFAULTS.subtitle,
        logoUrl: data.logo_url ? `${API.replace(/\/api$/, "")}${data.logo_url}` : DEFAULTS.logoUrl,
        faviconUrl: data.favicon_url ? `${API.replace(/\/api$/, "")}${data.favicon_url}` : DEFAULTS.faviconUrl,
      });
    } catch {
      setBranding(DEFAULTS);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    document.title = branding.title;
    let link = document.querySelector("link[rel='icon']");
    if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
    link.href = branding.faviconUrl;
  }, [branding]);

  return (
    <BrandingContext.Provider value={{ ...branding, refresh: load }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext) || DEFAULTS;
